import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { IFile } from '@model/file';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

import { actionItemCommentsKey } from './useActionItemCommentsQuery';

interface IData {
  comment: string;
  attachments: IFile[];
  aiType: string;
  actionItemId: number;
  commentId: number;
}

const aiCommentUpdateFn = (data: IData) =>
  apiClient.put(`${APP_API_URL_V2}fsd/action-item/${data.actionItemId}/comment/${data.commentId}`, {
    type: data.aiType,
    comment: data.comment,
    attachments: data.attachments,
  });

export const useAiCommentUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: aiCommentUpdateFn,
    onSuccess: (data, variables) => {
      const actionItemId = variables.actionItemId;
      if (actionItemId) {
        queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
        queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
        queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
      }
    },
  });
};
